// should update all templates to use this setup
import {createApp} from 'vue'
import EditFrivilligProfile from './EditFrivilligProfile'
import handleComponentProps from 'foundation/js/utils/handleComponentProps'

const el = '.kb-component--edit-frivillig-profile'

export default function(Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((EditFrivilligProfileDOM) => {
            const notificationWhenCommentOnSavedPosts =
                EditFrivilligProfileDOM.hasAttribute('notification-when-comment-on-saved-posts')
                
            const notificationWhenDirectMessage =
                EditFrivilligProfileDOM.hasAttribute('notification-when-direct-message')
            const notificationWhenNewDocument =
                EditFrivilligProfileDOM.hasAttribute('notification-when-new-document')
            const notificationWhenPostsOnGroups =
                EditFrivilligProfileDOM.hasAttribute('notification-when-posts-on-group')
            const addressVisible =
                EditFrivilligProfileDOM.hasAttribute('address-visible')
            const phonenumberVisible =
                EditFrivilligProfileDOM.hasAttribute('phonenumber-visible')
            const emailVisible =
                EditFrivilligProfileDOM.hasAttribute('email-visible')        
            const hasNewsletterSubscription =
                EditFrivilligProfileDOM.hasAttribute('subscribed-to-newsletter')                              
            const props = handleComponentProps(EditFrivilligProfile, EditFrivilligProfileDOM)
            
            const component = createApp(EditFrivilligProfile, {
                ...props,
                notificationWhenCommentOnSavedPosts,
                notificationWhenDirectMessage,
                notificationWhenNewDocument,
                notificationWhenPostsOnGroups,
                addressVisible,
                phonenumberVisible,
                emailVisible,
                hasNewsletterSubscription
            }).use(Store)
            component.mount(EditFrivilligProfileDOM)
        })
    }
}